import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CssBaseline from "@mui/material/CssBaseline";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../common";
import { handleMenuItemClick } from "./handleMenuItemClick.function";

export function AccountDropdownButton(props) {
  const history = useNavigate();
  return (
    <div>
      <CssBaseline />
      <Button
        sx={{
          color: "white",
          display: "flex",
          backgroundColor: "rgb(199, 171, 121)",
          "&:hover": {
            backgroundColor: "rgb(150,128,89)",
          },
          fontSize: "12px",
          textTransform: "capitalize",
          padding: "2px 5px 2px 12px",
        }}
        variant="contained"
        id="basic-button"
        aria-controls={props.open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={props.open ? "true" : undefined}
        onClick={props.handleClick}
      >
        Menu
        <KeyboardArrowDownIcon />
      </Button>

      <Menu
        id="basic-menu"
        anchorEl={props.anchorEl}
        open={props.open}
        onClose={props.handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {props.menuItems.map((item) =>
          item.access.map(
            (access, index) =>
              access === props.decoded.role && (
                <MenuItem
                  key={index}
                  onClick={() => handleMenuItemClick(item, history)}
                  sx={{ fontSize: "12px", mt: -1 }}
                >
                  {item.title}
                </MenuItem>
              ),
          ),
        )}
        <MenuItem
          onClick={() => logoutUser(history)}
          sx={{ fontSize: "12px", mt: -1 }}
        >
          Log Out
        </MenuItem>
      </Menu>
    </div>
  );
}
